export class InvoiceModel {
    propertyId: number;
    clientName: string;
    locationName: string;
    affiliateName: string;
    clientSalesRep: string;
    locationSalesRep: string;
    applicantFirstName: string;
    applicantLastName: string;
    applicantSSN: string;
    screeningDate: Date | string;
    locationCreatedDate: Date | string | null;
    reportNumber: number;
    screeningId: number;
    productName: string;
    searchName: string;
    addendumId: number;
    locationFirstOrderedDate: Date | string;
    additionalCharges: ChargesModel[];

    
    public get totalCharges() : number {
        var total = 0;
        this.additionalCharges.forEach(chg =>{
            total += chg.basePrice;
        })
        return total
    }
    
}

export class ChargesModel {
    searchName: string;
    basePrice: number;
    isPackagePrice: boolean;

    /**Netsuite inventory item mapping code. */
    NSMappingCode: number;
}